import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { homeApi } from '../api/home';
import BottomNav from '../components/BottomNav';
import Navbar from '../components/Navbar';
import './CircleDetail.css';

const CircleDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [comments, setComments] = useState([]);
  const [commentCount, setCommentCount] = useState(0);
  const [commentText, setCommentText] = useState('');
  const [replyTo, setReplyTo] = useState(null);
  const [loadingComments, setLoadingComments] = useState(false);
  const [submittingComment, setSubmittingComment] = useState(false);

  useEffect(() => {
    if (id) {
      fetchPostDetail();
      fetchComments();
    }
  }, [id]);

  const fetchPostDetail = async () => {
    try {
      setLoading(true);
      const result = await homeApi.getPostDetail({ tid: id });
      if (result.code === 200 || result.code === 1) {
        setPost(result.data.data);
        setCommentCount(result.data.data[0].commentCount || 0);
      } else {
        throw new Error(result.msg || '获取帖子详情失败');
      }
      setLoading(false);
    } catch (error) {
      console.error('获取帖子详情失败:', error);
      setLoading(false);
    }
  };

  const fetchComments = async () => {
    try {
      setLoadingComments(true);
      const result = await homeApi.getPostComments({ tid: id, page: 1 });
      if (result.code === 200 || result.code === 1) {
        setComments(result.data.data || []);
        setCommentCount(result.data.data.length || 0);
      } else {
        throw new Error(result.msg || '获取评论失败');
      }
      setLoadingComments(false);
    } catch (error) {
      console.error('获取评论失败:', error);
      setLoadingComments(false);
    }
  };

  const handleSubmitComment = async () => {
    if (!commentText.trim()) {
      alert('请输入评论内容');
      return;
    }

    try {
      setSubmittingComment(true);
      const result = await homeApi.addPostComment({
        goods_id: id,
        content: commentText,
        pid: replyTo?.id || 0,
        to_name: replyTo?.nickname || ''
      });
      if (result.code === 200 || result.code === 1) {
        setCommentText('');
        setReplyTo(null);
        fetchComments();
        alert('评论提交成功');
      } else {
        alert(result.msg || '评论提交失败，请重试');
      }
      setSubmittingComment(false);
    } catch (error) {
      console.error('提交评论失败:', error);
      alert('评论提交失败，请重试');
      setSubmittingComment(false);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleHome = () => {
    navigate('/');
  };

  const handleFollow = async () => {
    if (!post) return;
    
    try {
      const result = await homeApi.followUser({ id: post.member_id });
      if (result.code === 200 || result.code === 1) {
        setPost(prev => ({
          ...prev,
          is_follow: result.is_follow
        }));
      }
    } catch (error) {
      console.error('关注失败:', error);
      // 模拟关注
      setPost(prev => ({
        ...prev,
        is_follow: !prev.is_follow
      }));
    }
  };

  const handleLikePost = async () => {
    if (!post) return;
    
    try {
      const result = await homeApi.likePost({ id });
      if (result.code === 200 || result.code === 1) {
        setPost(prev => ({
          ...prev,
          likeCount: result.is_liked ? prev.likeCount + 1 : prev.likeCount - 1,
          is_like: result.is_liked
        }));
      }
    } catch (error) {
      console.error('点赞失败:', error);
      // 模拟点赞
      setPost(prev => ({
        ...prev,
        likeCount: prev.is_like ? prev.likeCount - 1 : prev.likeCount + 1,
        is_like: !prev.is_like
      }));
    }
  };

  const handleLikeComment = async (commentId, isChild = false, parentId = null) => {
    try {
      const result = await homeApi.likeComment({ id: commentId });
      if (result.code === 200 || result.code === 1) {
        // 更新评论点赞状态
        setComments(prev => prev.map(comment => {
          if (comment.id === commentId && !isChild) {
            return {
              ...comment,
              like_num: result.msg === '点赞成功' ? comment.like_num + 1 : comment.like_num - 1,
              is_like: result.msg === '点赞成功'
            };
          } else if (comment.id === parentId && isChild) {
            return {
              ...comment,
              child: comment.child.map(child => {
                if (child.id === commentId) {
                  return {
                    ...child,
                    like_num: result.msg === '点赞成功' ? child.like_num + 1 : child.like_num - 1,
                    is_like: result.msg === '点赞成功'
                  };
                }
                return child;
              })
            };
          }
          return comment;
        }));
      }
    } catch (error) {
      console.error('点赞评论失败:', error);
      // 模拟点赞
      setComments(prev => prev.map(comment => {
        if (comment.id === commentId && !isChild) {
          return {
            ...comment,
            like_num: comment.is_like ? comment.like_num - 1 : comment.like_num + 1,
            is_like: !comment.is_like
          };
        } else if (comment.id === parentId && isChild) {
          return {
            ...comment,
            child: comment.child.map(child => {
              if (child.id === commentId) {
                return {
                  ...child,
                  like_num: child.is_like ? child.like_num - 1 : child.like_num + 1,
                  is_like: !child.is_like
                };
              }
              return child;
            })
          };
        }
        return comment;
      }));
    }
  };

  const handleReply = (comment) => {
    setReplyTo(comment);
  };

  const handleCancelReply = () => {
    setReplyTo(null);
  };

  const handleViewUser = (userId) => {
    // 跳转到用户主页
    console.log('查看用户:', userId);
  };

  const handleViewTag = (tagId) => {
    // 跳转到标签页面
    console.log('查看标签:', tagId);
  };

  if (loading) {
    return <div className="loading">加载中...</div>;
  }

  if (!post) {
    return <div className="empty">帖子不存在</div>;
  }

  return (
    <div className="circle-detail">
      <Navbar showHome={false} />

      {/* 帖子内容 */}
      <div className="content-area">
        {/* 作者信息 */}
        <div className="post-author">
          <div className="author-info" onClick={() => handleViewUser(post.member_id)}>
            <div className="author-avatar">
                <img src={post.userAvatar || '/avatar.jpg'} alt={post.userName} />
              </div>
            <div className="author-details">
              <div className="author-name">
                {post.userName}
                <span className="user-level">LV {post.lv}</span>
              </div>
              <div className="post-time">
                {post.date}
              </div>
            </div>
          </div>
          <div className="follow-button">
            <button 
              className={`follow-btn ${post.is_follow ? 'followed' : ''}`}
              onClick={handleFollow}
            >
              {post.is_follow ? '已关注' : '+ 关注'}
            </button>
          </div>
        </div>

        {/* 标签 */}
        {post.label && post.label.length > 0 && (
          <div className="post-tags">
            {post.label.map((tag) => (
              <div key={tag.id} className="tag-item" onClick={() => handleViewTag(tag.id)}>
                <span className="tag-prefix">#</span>
                <span className="tag-name">{tag.title}</span>
              </div>
            ))}
          </div>
        )}

        {/* 帖子内容 */}
        <div className="post-content">
          <div dangerouslySetInnerHTML={{ __html: post.content }} />
        </div>

        {/* 帖子图片 */}
        {post.mainImage && post.mainImage.length > 0 && (
          <div className="post-images">
            {post.mainImage.map((image, index) => (
              <img key={index} src={image} alt={`图片 ${index + 1}`} />
            ))}
          </div>
        )}

        {/* 帖子统计 */}
        <div className="post-stats">
          <div className="stats-left">
            <div className="view-users">
              <div className="user-avatars">
                {post.viewUser?.latestUserAvatar?.map((avatar, index) => (
                  <div key={index} className="user-avatar-small">
                    <img src={avatar || '/avatar.jpg'} alt={`用户 ${index + 1}`} />
                  </div>
                ))}
              </div>
              <span className="view-count">{post.likeCount}人</span>
            </div>
          </div>
          <div className="stats-right">
            <span className="stat-item">
              👁️ {post.collectionCount}
            </span>
            <span className="stat-item">
              💬 {post.commentCount}
            </span>
            <span className="stat-item">
              👍 {post.likeCount}
            </span>
          </div>
        </div>

        {/* 操作按钮 */}
        <div className="action-buttons">
          <button 
            className={`action-button like-button ${post.is_like ? 'liked' : ''}`}
            onClick={handleLikePost}
          >
            <span className="button-icon">{post.is_like ? '❤️' : '🤍'}</span>
            <span className="button-text">{post.is_like ? '取消点赞' : '点赞'}</span>
          </button>
          <button className="action-button share-button">
            <span className="button-icon">📤</span>
            <span className="button-text">分享</span>
          </button>
        </div>

        {/* 评论区 */}
        <div className="comments-section">
          <h3 className="comments-title">
            最新评论 ({commentCount})
          </h3>

          {/* 评论列表 */}
          <div className="comments-list">
            {loadingComments ? (
              <div className="loading-comments">加载评论中...</div>
            ) : comments.length > 0 ? (
              comments.map((comment) => (
                <div key={comment.id} className="comment-item">
                  {/* 评论头部 */}
                  <div className="comment-header">
                    <div className="comment-author" onClick={() => handleViewUser(comment.member_id)}>
                      <img src={comment.avatar || '/avatar.jpg'} alt={comment.nickname} />
                      <div className="comment-author-info">
                        <div className="comment-author-name">
                          {comment.user_id === comment.fa_user_id && <span className="author-badge">作者</span>}
                          {comment.nickname}
                        </div>
                        <div className="comment-meta">
                          <span className="comment-time">{comment.create_time}</span>
                          {((comment.user_id === comment.ziji_id || comment.fa_user_id === comment.ziji_id) && (
                            <span className="comment-action delete-action">删除</span>
                          ))}
                          {comment.fa_user_id === comment.ziji_id && comment.is_ding === 0 && (
                            <span className="comment-action top-action">置顶</span>
                          )}
                          {comment.fa_user_id === comment.ziji_id && comment.is_ding === 1 && (
                            <span className="comment-action cancel-top-action">取消置顶</span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="comment-like">
                      <button 
                        className={`like-button ${comment.is_like ? 'liked' : ''}`}
                        onClick={() => handleLikeComment(comment.id)}
                      >
                        {comment.is_like ? '❤️' : '🤍'}
                        <span>{comment.like_num}</span>
                      </button>
                    </div>
                  </div>

                  {/* 评论内容 */}
                  <div className="comment-content" onClick={() => handleReply(comment)}>
                    {comment.is_ding && (
                      <span className="top-badge">作者置顶</span>
                    )}
                    <div dangerouslySetInnerHTML={{ __html: comment.content }} />
                  </div>

                  {/* 评论操作 */}
                  <div className="comment-actions">
                    <button className="comment-action reply-action" onClick={() => handleReply(comment)}>
                      💬 回复
                    </button>
                  </div>

                  {/* 子评论 */}
                  {comment.child && comment.child.length > 0 && (
                    <div className="child-comments">
                      {comment.child.map((childComment) => (
                        <div key={childComment.id} className="child-comment">
                          <div className="child-comment-header" onClick={() => handleReply(childComment)}>
                            <span className="child-author-name">
                              {childComment.user_id === childComment.fa_user_id && <span className="author-badge">作者</span>}
                              {childComment.nickname}:
                            </span>
                            {childComment.to_name && (
                              <>
                                <span className="reply-to">回复</span>
                                <span className="to-name">:{childComment.to_name}</span>
                              </>
                            )}
                          </div>
                          <div className="child-comment-content">
                            <div dangerouslySetInnerHTML={{ __html: childComment.content }} />
                          </div>
                          <div className="child-comment-meta">
                            <span className="child-comment-time">{childComment.create_time}</span>
                            {((childComment.user_id === childComment.ziji_id || comment.fa_user_id === childComment.ziji_id) && (
                              <span className="child-comment-action delete-action">删除</span>
                            ))}
                            <button 
                              className={`child-comment-action like-action ${childComment.is_like ? 'liked' : ''}`}
                              onClick={() => handleLikeComment(childComment.id, true, comment.id)}
                            >
                              {childComment.is_like ? '❤️' : '🤍'} {childComment.like_num}
                            </button>
                            <button className="child-comment-action reply-action" onClick={() => handleReply(childComment)}>
                              💬 回复
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="no-comments">暂无评论，快来发表你的看法吧！</div>
            )}
          </div>

          {/* 评论输入框 */}
          <div className="comment-input-section">
            <div className="user-avatar-small">
              <img src="http://localhost:8000/uploads/portal/201610/11/153821bzbgff4ys422bwis.jpg" alt="我的头像" />
            </div>
            <div className="comment-input-container">
              {replyTo && (
                <div className="reply-info">
                  <span className="reply-text">回复: {replyTo.nickname}</span>
                  <button className="cancel-reply" onClick={handleCancelReply}>取消</button>
                </div>
              )}
              <input
                type="text"
                className="comment-input"
                placeholder={replyTo ? `回复 ${replyTo.nickname}...` : '说点啥吧'}
                value={commentText}
                onChange={(e) => setCommentText(e.target.value)}
                maxLength={100}
              />
            </div>
            <button 
              className="submit-comment"
              onClick={handleSubmitComment}
              disabled={submittingComment}
            >
              {submittingComment ? '发送中...' : '发送'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CircleDetail;